/**
 * @see src/CamBundle/Message/Websocket/Schedule/ScheduleUpdated.php
 */

import * as t from 'io-ts';
import { Type } from './Type';

export const ScheduleUpdatedC = t.type({
    type: t.literal(Type.UPDATE),
    id: t.number,
});

export type ScheduleUpdated = t.TypeOf<typeof ScheduleUpdatedC>;
